import { DeprecationsPlugin, PromisesPlugin, TemplateParamsPlugin, AliasSortingPlugin } from "/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/node_modules/@unhead/vue/dist/plugins.mjs";
export default {
  disableDefaults: true,
  disableCapoSorting: false,
  plugins: [DeprecationsPlugin, PromisesPlugin, TemplateParamsPlugin, AliasSortingPlugin],
}